module.exports = __webpack_public_path__ + "static/media/1.35d78d34.jpg";